const API_BASE = process.env.REACT_APP_API_URL || "";

const apiFetch = async (path, options = {}) => {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
    ...options,
  });

  if (res.status === 401) {
    return null;
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed: ${res.status}`);
  }

  return res.json();
};

export const authApi = {
  me: () => apiFetch("/auth/me"),
  login: (email, password) =>
    apiFetch("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    }),
  register: (email, password, name) =>
    apiFetch("/auth/register", {
      method: "POST",
      body: JSON.stringify({ email, password, name }),
    }),
  logout: () => apiFetch("/auth/logout", { method: "POST" }),
};

export const transactionsApi = {
  list: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiFetch(`/api/transactions${query ? `?${query}` : ""}`);
  },
  summary: () => apiFetch("/api/transactions/summary"),
  fundingSummary: (month) =>
    apiFetch(`/api/transactions/funding-summary?month=${month}`),
  create: (data) =>
    apiFetch("/api/transactions", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  delete: (id) => apiFetch(`/api/transactions/${id}`, { method: "DELETE" }),
};

export const usersApi = {
  updateCurrency: (currency) =>
    apiFetch("/api/users/me/currency", {
      method: "PATCH",
      body: JSON.stringify({ currency }),
    }),
};

export const adminApi = {
  users: () => apiFetch("/api/admin/users"),
  createUser: (email, password, name, role) =>
    apiFetch("/api/admin/users", {
      method: "POST",
      body: JSON.stringify({ email, password, name, role }),
    }),
  updateRole: (userId, role) =>
    apiFetch(`/api/admin/users/${userId}/role`, {
      method: "PATCH",
      body: JSON.stringify({ role }),
    }),
  resetPassword: (userId, password) =>
    apiFetch(`/api/admin/users/${userId}/password`, {
      method: "PATCH",
      body: JSON.stringify({ password }),
    }),
  deleteUser: (userId) =>
    apiFetch(`/api/admin/users/${userId}`, { method: "DELETE" }),
  transactions: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiFetch(`/api/admin/transactions${query ? `?${query}` : ""}`);
  },
  summary: () => apiFetch("/api/admin/summary"),
  deleteTransaction: (id) =>
    apiFetch(`/api/admin/transactions/${id}`, { method: "DELETE" }),
  impersonate: (userId) =>
    apiFetch(`/api/admin/impersonate/${userId}`, { method: "POST" }),
  stopImpersonating: () =>
    apiFetch("/api/admin/stop-impersonating", { method: "POST" }),
};

export const uploadsUrl = (filename) => `${API_BASE}/uploads/${filename}`;

// Parse receipt_path (legacy single string or JSON array) into an array of filenames
export const parseReceiptPaths = (receiptPath) => {
  if (!receiptPath) return [];
  if (receiptPath.startsWith("[")) {
    try {
      return JSON.parse(receiptPath);
    } catch {
      return [];
    }
  }
  return [receiptPath];
};
